import Choices from 'choices.js';

(function ($) {
  // Initialize custom select
  const customSelects = document.querySelectorAll('.js-custom-select');
  customSelects.forEach((select) => {
    new Choices(select, {
      searchEnabled: false,
      itemSelectText: '',
    });
  });

  // Autosubmit form after select option is changed
  $('.js-auto-submit select').on('change', function () {
    $(this).closest('form').trigger('submit');
  });

  // Readonly for agreement checkbox
  $('.agreement-checkbox-hidden input[type=checkbox]').attr(
    'onclick',
    'return false;',
  );

  // Run scripts on page load
  load_form_scripts();

  // We need to run scripts when ajax is finished as well
  // TODO: not working, fix this
  $(document).on('gform_post_render', function () {
    // console.log('rerendered')
    load_form_scripts();
  });

  /**
   * Wrap all scripts run on forms
   */
  function load_form_scripts() {
    // Get all input field types, so we can use it in various places
    var inputs =
      'input[type="text"], input[type="email"], input[type="url"], input[type="tel"], input[type="file"], textarea, select, input[type="radio"], input[type="checkbox"]';

    /**
     * Add is-focused class to parent field wrapper so we can style it properly
     */
    $(inputs)
      .on('focus', function () {
        $(this).closest('.gfield').addClass('is-focused');
      })
      .on('blur', function () {
        $(this).closest('.gfield').removeClass('is-focused');
      });

    /**
     * Disable or set read-only field, if .gfield has class 'is-disabled' or 'is-readonly'
     */
    $('.gfield.is-disabled').find(inputs).attr('disabled', '');
    $('.gfield.is-readonly').find(inputs).attr('readonly', '');

    /**
     * Set proper label title when file is added.
     * Source: https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/
     */
    $('.gfield_fileupload_wrapper input[type="file"]').each(function () {
      var $input = $(this),
        $label = $input
          .closest('.gfield_fileupload_wrapper')
          .find('.gfield_label'),
        labelVal = $label.html();

      $input.on('change', function (e) {
        var fileName = '';

        if (this.files && this.files.length > 1)
          fileName = (this.getAttribute('data-multiple-caption') || '').replace(
            '{count}',
            this.files.length,
          );
        else if (e.target.value) fileName = e.target.value.split('\\').pop();

        if (fileName) $label.html(fileName);
        else $label.html(labelVal);
      });

      // Firefox bug fix
      // $input.on('focus', function () {
      // 	$input.addClass('has-focus');
      // })
      // .on('blur', function () {
      // 	$input.removeClass('has-focus');
      // });
    });

    /**
     * Set proper Global Job Agreement text by selected country
     */
    $('.js-agreement-country select').on('change', function () {
      var slug = $(this).val();
      var form = $(this).closest('.gform_wrapper');

      if (slug !== '') {
        $.get(
          GLOBAL.ajax,
          {
            slug: slug,
            action: 'get-agreement',
          },
          function (result) {
            result = result.data || '';
            form.find('.agreement-field .gfield_checkbox label').html(result);
          },
        );
      }
    });

    $('.js-agreement-country select').trigger('change');

    /**
     * Set proper Single Job Agreement text by selected country
     */
    $('.js-single-job-agreement-country select').on('change', function () {
      var slug = $(this).val();
      var form = $(this).closest('.gform_wrapper');

      if (slug !== '') {
        $.get(
          GLOBAL.ajax,
          {
            slug: slug,
            action: 'get-single-job-agreement',
          },
          function (result) {
            result = result.data || '';
            form.find('.agreement-field .gfield_checkbox label').html(result);
          },
        );
      }
    });

    $('.js-single-job-agreement-country select').trigger('change');
  }
})(jQuery);
